import { PartialSetRequest } from '../mutations';

export const correctDependentSettingsInSetRequest = (request: PartialSetRequest) => {
  if (request.setting && 'inboxLocationSetting' in request.setting) {
    const processConfirmationsQuietlyShouldBeForced =
      // `processConfirmationsQuietly` must be true if `processConfirmationsSilently` is true, and
      // `processConfirmationsSilently` must be being updated
      request.setting.inboxLocationSetting?.processConfirmationsSilently === true &&
      (!request.mask?.paths || request.mask.paths.some((path) => path.includes('processConfirmationsSilently')));
    if (processConfirmationsQuietlyShouldBeForced) {
      return {
        ...request,
        setting: {
          ...request.setting,
          inboxLocationSetting: {
            ...request.setting.inboxLocationSetting,
            processConfirmationsQuietly: true,
          },
        },
      };
    }
  }

  return request;
};
